import { Dispatch, SetStateAction, useEffect } from 'react'
import { StockType } from 'types/stock'
import { parseToDate } from 'lib/helper'
import { differenceInMinutes } from 'date-fns'
import { StoreDeliveryBreadType } from 'types/storeDeliveryBread'

const useIndividualScheduleDates = (
  storeDeliveryBread: StoreDeliveryBreadType,
  stockList: StockType[],
  setIndividualSettingDates: Dispatch<SetStateAction<Date[]>>
) => {
  useEffect(() => {
    if (!storeDeliveryBread) return
    const dates = stockList.reduce((prev: Date[], stock) => {
      const date = parseToDate(stock.date)
      const hoursToDeadline = differenceInMinutes(date, stock.deadline.toDate()) / 60
      if (
        storeDeliveryBread.hours_to_deadline === hoursToDeadline &&
        storeDeliveryBread.maximum_order === stock.stock
      ) {
        return prev
      } else {
        return [...prev, date]
      }
    }, [])
    setIndividualSettingDates([...dates])
  }, [storeDeliveryBread, stockList])
}

export default useIndividualScheduleDates
